$( document ).ready(function() {
  $( function() {
 
    $( '.searchbar' ).autocomplete({
      minLength: 2,
      source: function(request, response) {
        var results = $.ui.autocomplete.filter(searchterms, request.term);
        response(results.slice(0, 5));
      },
      focus: function( event, ui ) {
        $( '.searchbar' ).val( ui.item.label );
        return false;
      },
      select: function( event, ui ) {
        $( '.searchbar' ).val( ui.item.label ).addClass('spacing');
        $( '#suggestions' ).val( ui.item.value );
        if (ui.item.desc == 'single product') {
        } else {
          if (ui.item.desc){
            $( '.type' ).replaceWith('<input type="hidden" class="type" name="type" value="'+ ui.item.desc +'">');
            $('.extra').replaceWith( '<span class="extra"> in ' + ui.item.desc + '</span>' );
          }
        }
        $('.search').submit();
        return false;
      }

    })
    .autocomplete( 'instance' )._renderItem = function( ul, item ) {
      if (item.desc) {
        var category = '<small class="type"> in <b class="link-blue">' + item.desc + '</b></small></div>'
      } else {
        var category = '</div>'
      }
      return $( '<li>' )
        .append( '<div>' + item.label + category ) 
        .appendTo( ul );
    };
  });
  
}); 